//For combine reducers in file

import { combineReducers } from "redux";
import { patientDetailsReducer, appointmentTypeReducer, slotSelectionReducer, insurance } from "./appointmentReducer";

const reducers = combineReducers ({
    patientDetails: patientDetailsReducer,
    appointmentType: appointmentTypeReducer,
    slotselection: slotSelectionReducer,
    insurance: insurance
})

export default reducers;